import { useCallback, useState } from "react";
import qapi from "views_shared/app/javascript/api";
import qlog from "views_shared/app/javascript/scripts/qlog";

// Past this the click stops waiting on the AI rewrite and opens the form with the raw story idea.
export const TRANSFORM_TIMEOUT_MS = 8000;

// V1-COMPAT: V1 hosts this tree too and has no /profiles/:id/my_requests/new; its own new-request
// page takes the same title/details params.
function newRequestPath() {
  if (globalThis.Qwoted?.V1_HOSTED) return "/reporter_requests/new_v2";
  return `/profiles/${globalThis.Qwoted?.CURRENT_PROFILE_ID}/my_requests/new`;
}

export function callForSourcesUrl({ title, details } = {}) {
  const params = new URLSearchParams();
  if (title) params.set("title", title);
  if (details) params.set("details", details);
  const query = params.toString();
  return query ? `${newRequestPath()}?${query}` : newRequestPath();
}

function withTimeout(promise, ms) {
  let timer;
  const timeout = new Promise((resolve) => {
    timer = setTimeout(() => resolve({ error: new Error(`Timed out after ${ms}ms`) }), ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}

function isModifiedClick(event) {
  return event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
}

// The link's href carries the raw story idea, so a new-tab click (or a failed script) still
// prefills. A plain click first asks enrich to rewrite the expert's pitch as a reporter's request,
// falling back to the raw text if that fails or is slow.
export default function useCallForSources(hit) {
  const [isPreparing, setIsPreparing] = useState(false);
  const href = callForSourcesUrl({ title: hit.title, details: hit.text });

  const onClick = useCallback(
    async (event) => {
      if (isModifiedClick(event)) return;
      event.preventDefault();
      if (isPreparing) return;
      setIsPreparing(true);

      const pitchText = [hit.title, hit.lede, hit.preamble, hit.text].filter(Boolean).join(" ");
      const { data, error } = await withTimeout(
        qapi.publicPitches.transformToRequest(pitchText).catch((e) => ({ error: e })),
        TRANSFORM_TIMEOUT_MS,
      );
      if (error) qlog.error("Story idea → request rewrite failed; using the raw story idea:", error);

      const result = data?.result;
      window.location.href = callForSourcesUrl({
        title: result?.title || hit.title,
        details: result?.details || hit.text,
      });
    },
    [hit, isPreparing],
  );

  return { href, onClick, isPreparing };
}
